import React, { useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'
import { Expression } from '~/prix/types/expression'
import { FilteredType } from './viewSelectModalVariable.filters.component'

const InputWrapper = styled.div`
  max-width: 150px;
  height: 2.6rem;

  input {
    width: 100%;
    height: 100%;
    padding: 0.5rem;
    border: 1px solid #e6e6e6;
    color: #999999;
    background-color: #ffff;
    border-radius: 5px;
  }

  .disabled {
    background-color: #f2f2f2;
  }

  @media screen and (max-width: 768px) {
    max-width: 100%;
  }
`

interface InputItemFilterProps {
  expression: Expression
  addToExpression: (expression: FilteredType, isBetween?: boolean) => void
  value: string | undefined
  sideOfExpression?: 'left' | 'right'
}

const InputItemFilter: React.FC<InputItemFilterProps> = ({
  expression,
  addToExpression,
  value,
  sideOfExpression,
}) => {
  const [isDisabled, setIsDisabled] = useState(Boolean(value))
  const [draftValue, setDraftValue] = useState(value ?? '')
  const hasValue = useMemo(() => {
    if (value !== undefined && value !== '') {
      return true
    }
    return false
  }, [value])

  useEffect(() => {
    setDraftValue(value ?? '')
    setIsDisabled(Boolean(value))
  }, [value])

  const checkDisabled = () => {
    if (hasValue) {
      return true
    }
    return isDisabled
  }

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (
      event.key === 'Enter' &&
      expression.kind === 'binary' &&
      expression.left.kind === 'property' &&
      (expression.operator === 'BETWEEN' || expression.operator === 'NOT BETWEEN')
    ) {
      const typeOfPreviousProperty = expression.left.literalType
      const newExpression = {
        value: {
          [sideOfExpression as string]: {
            kind: 'literal',
            type: 'expression',
            literalType: typeOfPreviousProperty,
            value: draftValue,
          },
        },
      }
      addToExpression(newExpression, true)
      setIsDisabled(true)
      return
    }
    if (
      event.key === 'Enter' &&
      expression.kind === 'binary' &&
      expression.left.kind === 'property'
    ) {
      const typeOfPreviousProperty = expression.left.literalType
      const newExpression = {
        value: {
          kind: 'literal',
          type: 'expression',
          literalType: typeOfPreviousProperty,
          value: draftValue,
        },
      }

      addToExpression(newExpression as FilteredType)
      setIsDisabled(true)
    }
  }
  return (
    <InputWrapper>
      <input
        onKeyDown={handleKeyPress}
        onChange={event => setDraftValue(event.target.value)}
        disabled={checkDisabled()}
        value={draftValue}
        className={checkDisabled() ? 'disabled' : ''}
      />
    </InputWrapper>
  )
}

export default InputItemFilter
